
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^1(1004|7732)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
